import { render, staticRenderFns } from "./BasicPriceUpdate.vue?vue&type=template&id=435633dd"
import script from "./BasicPriceUpdate.vue?vue&type=script&lang=ts"
export * from "./BasicPriceUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports